export default "__VITE_ASSET__m9rEy3eS__"